import Class from './c-chart-multiple-axes-view';
import './c-chart-multiple-axes-view@.vue';

export default Class;